import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Check, Eye } from 'lucide-react';
import { MatchStrength } from './MatchStrength';
interface MatchCardProps {
  name: string;
  tagline: string;
  image: string;
  matchPercentage: number;
  reasons: string[];
  explanation: string;
  type: 'brand' | 'organizer';
  onViewProfile?: () => void;
  onConnect?: () => void;
}
export function MatchCard({
  name,
  tagline,
  image,
  matchPercentage,
  reasons,
  explanation,
  type,
  onViewProfile,
  onConnect
}: MatchCardProps) {
  const accentColor = type === 'brand' ? 'text-cyan-400' : 'text-purple-400';
  const buttonBg = type === 'brand' ? 'bg-cyan-500 hover:bg-cyan-400' : 'bg-purple-500 hover:bg-purple-400';
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} className="bg-slate-800 border border-slate-700 rounded-2xl overflow-hidden hover:border-slate-600 transition-colors group" data-id="element-202">
      <div className="p-6" data-id="element-203">
        <div className="flex justify-between items-start mb-4" data-id="element-204">
          <div className="flex items-center gap-4" data-id="element-205">
            <div className="w-12 h-12 rounded-lg bg-slate-700 overflow-hidden" data-id="element-206">
              <img src={image} alt={name} className="w-full h-full object-cover" data-id="element-207" />
            </div>
            <div data-id="element-208">
              <h3 className="text-lg font-bold text-white" data-id="element-209">{name}</h3>
              <p className="text-sm text-slate-400" data-id="element-210">{tagline}</p>
            </div>
          </div>
          <MatchStrength percentage={matchPercentage} data-id="element-211" />
        </div>

        <div className="mb-4" data-id="element-212">
          <h4 className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-2" data-id="element-213">
            Why it's a match
          </h4>
          <ul className="space-y-2" data-id="element-214">
            {reasons.map((reason, i) => <li key={i} className="flex items-start gap-2 text-sm text-slate-300" data-id="element-215">
                <Check size={14} className={`mt-1 flex-shrink-0 ${accentColor}`} data-id="element-216" />
                {reason}
              </li>)}
          </ul>
        </div>

        <div className="bg-slate-900/50 rounded-lg p-3 mb-6" data-id="element-217">
          <p className="text-xs text-slate-400 italic" data-id="element-218">"{explanation}"</p>
        </div>

        <div className="flex gap-3" data-id="element-219">
          <button onClick={onViewProfile} className="flex-1 py-3 rounded-full border border-slate-600 hover:border-slate-400 text-white font-medium text-sm transition-colors flex items-center justify-center gap-2" data-id="element-220">
            <Eye size={16} data-id="element-221" /> View Profile
          </button>
          <button onClick={onConnect} className={`flex-1 py-3 rounded-full text-slate-900 font-bold text-sm transition-all flex items-center justify-center gap-2 ${buttonBg}`} data-id="element-222">
            Connect <ArrowRight size={16} data-id="element-223" />
          </button>
        </div>
      </div>
    </motion.div>;
}